export const app = {
  search: "Search",
  
};
